export const pageRange = [5, 10, 50, 100, 500];
export const defaultPageRange = 500;
